import React, { useEffect, useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { company } from '../mock';
import { useLang } from '../i18n/LanguageContext';

export default function WhatsAppButton() {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(false);
  const [hint, setHint] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setHint(false), 6000);
    return () => clearTimeout(timer);
  }, []);

  const preMsg = lang === 'gu'
    ? 'નમસ્તે! હું Vedyah Exim ની સેવાઓ માટે પૂછપરછ કરવા માગું છું.'
    : "Hello! I'd like to enquire about Vedyah Exim's services.";
  const waLink = `https://wa.me/${company.phoneRaw}?text=${encodeURIComponent(preMsg)}`;

  return (
    <div className="fixed bottom-6 left-6 z-40 flex items-end gap-3">
      {open && (
        <div className="mb-16 absolute bottom-0 left-0 w-72 bg-white rounded-lg shadow-2xl border border-slate-200 overflow-hidden animate-in fade-in slide-in-from-bottom-2">
          <div className="px-4 py-3 flex items-center gap-2" style={{ background: '#25D366', color: 'white' }}>
            <MessageCircle size={18} />
            <div className="font-semibold">Vedyah Exim</div>
            <button onClick={() => setOpen(false)} className="ml-auto text-white/80 hover:text-white"><X size={16} /></button>
          </div>
          <div className="p-4">
            <div className="text-xs text-slate-500 mb-2">{lang === 'gu' ? 'સામાન્યત: વિનાવિલંબનો પ્રતિસાદ' : 'Typically replies within minutes'}</div>
            <div className="bg-slate-100 p-3 rounded-md text-sm mb-3">
              {lang === 'gu' ? 'નમસ્તે! શું મદદ જોઈએ? ક્વોટ, ટ્રેકિંગ કે કોઈ પ્રશ્ન?' : "Hi there! How can we help? Quote, tracking or general enquiry?"}
            </div>
            <a href={waLink} target="_blank" rel="noreferrer" className="block text-center py-2 rounded-md font-semibold text-white transition-transform hover:scale-[1.02]" style={{ background: '#25D366' }}>
              {lang === 'gu' ? 'WhatsApp પર ચેટ શરૂ કરો' : 'Start Chat on WhatsApp'}
            </a>
          </div>
        </div>
      )}

      <button
        aria-label={t('wa.tooltip')}
        onClick={() => { setOpen((v) => !v); setHint(false); }}
        className="relative w-14 h-14 rounded-full shadow-2xl flex items-center justify-center text-white transition-transform hover:scale-110"
        style={{ background: '#25D366' }}
      >
        <span className="absolute inset-0 rounded-full animate-ping opacity-40" style={{ background: '#25D366' }} />
        <MessageCircle size={26} className="relative" />
      </button>

      {hint && !open && (
        <div className="bg-white rounded-lg px-3 py-2 text-sm shadow-lg border border-slate-200 mb-1 animate-in fade-in slide-in-from-left-2">
          {t('wa.tooltip')}
        </div>
      )}
    </div>
  );
}
